<template>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center p-2 mb-1 border-bottom">
	<div class="fs-4">
		Історія налаштувань усіх СКЗ
	</div>
</div>

<events-section
	:station-ids="stationsStore.stationsArray.map((station) => station.id)"
	:events-filter="['station_passport_edit',]"
	:table-height="easyDataTableHeight(false) - Number(headerHeight.replace(/[^0-9]/gi, ''))"
	:is-not-acknowledge-events="false"
	:is-about-pop-up="false"
/>
</template>




<script>
import EventsSection from '@/components/EventsSection/EventsSection.vue'
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { useSessionStore } from '@/stores/SessionStore.js'
import { easyDataTableHeight } from '@/helpers.js'

export default {
	inject: [ 'headerHeight'],
	
	components: {
		EventsSection
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()
		const sessionStore = useSessionStore()

		return {
			easyDataTableHeight,
			accountStore,
			stationsStore,
			sessionStore,
		}
	},

	data() {
		return {}
	},

	created() {
		if (this.stationsStore.isNoStations) {
			// Read all stations for station IDs list load
			this.stationsStore.readStations()
		}
	},

	mounted() {
		document.title = "Історія налаштувань усіх СКЗ"
	},

	methods: {},

	computed: {},
}
</script>




<style src="@/assets/table.css" scoped></style>